import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CreateFromKeywordsStore } from './create-form-keywords.store';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
  selector: 'app-create-form-keywords',
  templateUrl: './create-form-keywords.component.html',
  styleUrls: ['./create-form-keywords.component.scss'],
  providers: [CreateFromKeywordsStore]
})
export class CreateFormKeywordsComponent implements OnInit, ControlValueAccessor  {
  onChange: any = () => {}
  onTouch: any = () => {}
  value: string =''

  constructor(
    public ngControl: NgControl,
  ) {
    ngControl.valueAccessor = this;
  }

  ngOnInit(): void {

  }

  writeValue(value: string | undefined){
    if(value){
      this.value = value
    }
  }

  registerOnChange(fn: any){
    this.onChange = fn
  }

  registerOnTouched(fn: any){
    this.onTouch = fn
  }

  onInputChange(event: any){
    if(!this.ngControl.touched){
      this.onTouch()
    }
    this.onChange(event)
  }

}
